import React from 'react';
import { Link } from 'react-router-dom';

const MainPage = () => {
  return (
    <div className="min-h-screen flex flex-col pt-12">
      {/* Fixed Header */}
      <header className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-sm border-b border-gray-200 shadow-sm z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-12">
            <div className="flex items-center">
              <div className="h-8 w-8 bg-gradient-to-tr from-blue-500 to-cyan-400 rounded-full flex items-center justify-center shadow-sm">
                <img 
                  src="/oil.png" 
                  alt="Oil Tank Sweep" 
                  className="h-5 w-5 brightness-0 invert" 
                />
              </div>
              <h1 className="text-xl font-semibold ml-3 bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent">OilTank.App</h1>
            </div>
            
            <div className="flex items-center space-x-4">
              <Link 
                to="/login"
                className="px-4 py-2 text-sm font-medium text-slate-700 hover:text-slate-900"
              >
                Sign In
              </Link>
              <Link 
                to="/register"
                className="px-4 py-2 text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 rounded-md"
              >
                Create Account
              </Link>
            </div>
          </div>
        </div>
      </header>
      
      {/* Hero Section */}
      <div className="oiltank-blue-bg flex-grow flex items-center" style={{ backgroundColor: "#1977cc" }}>
        <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
              <span className="block">Manage Your</span>
              <span className="block">Oil Tank Sweep Reports</span>
            </h1>
            <p className="mt-6 max-w-lg mx-auto text-xl text-white text-opacity-90">
              Keep all your tank sweep reports in one place, plus access related documents like WDI, radon, and other inspection files. Add notes and details, and view them anytime, from anywhere.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row sm:justify-center sm:space-x-4 space-y-4 sm:space-y-0">
              <Link
                to="/register"
                className="w-full sm:w-auto px-8 py-3 text-center border border-transparent text-base font-medium rounded-md text-[#1977cc] bg-white hover:bg-gray-50"
              >
                Get Started
              </Link>
              <Link
                to="/login"
                className="w-full sm:w-auto px-8 py-3 text-center border border-white text-base font-medium rounded-md text-white hover:bg-[#156bbb]"
              >
                Sign In
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      {/* Features */}
      <div className="py-16 bg-white text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-16">
            <h2 className="text-sm font-semibold tracking-wide uppercase" style={{ color: "#1977cc" }}>FEATURES</h2>
            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              A better way to manage your reports
            </p>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
              Everything you need to keep track of your oil tank sweep reports and add your own notes.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-12 md:grid-cols-4">
            <div className="flex flex-col items-center">
              <div className="mb-4 w-16 h-16 flex items-center justify-center rounded-md" style={{ backgroundColor: "#1977cc" }}>
                <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                Easy Report Storage
              </h3>
              <p className="mt-2 text-base text-gray-600">
                Save all your tank sweep reports in one centralized location.
              </p>
            </div>

            <div className="flex flex-col items-center">
              <div className="mb-4 w-16 h-16 flex items-center justify-center rounded-md" style={{ backgroundColor: "#1977cc" }}>
                <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                Quick Access
              </h3>
              <p className="mt-2 text-base text-gray-600">
                Access your reports anytime, from any device with internet access.
              </p>
            </div>

            <div className="flex flex-col items-center">
              <div className="mb-4 w-16 h-16 flex items-center justify-center rounded-md" style={{ backgroundColor: "#1977cc" }}>
                <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                Secure Storage
              </h3>
              <p className="mt-2 text-base text-gray-600">
                Your reports are securely stored and accessible only by you.
              </p>
            </div>

            <div className="flex flex-col items-center">
              <div className="mb-4 w-16 h-16 flex items-center justify-center rounded-md" style={{ backgroundColor: "#1977cc" }}>
                <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                All-in-One Document Hub
              </h3>
              <p className="mt-2 text-base text-gray-600">
                Access multiple document types - inspection, WDI, radon reports, and custom files - all in one organized place.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-center text-sm text-gray-500">
            &copy; 2024 OilTank Portal. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default MainPage;